export const getAddressLabelsByCountry = (country?: string) => {
  switch (country) {
    case "Canada":
      return {
        zip: "Postal Code",
        state: "Province",
        city: "City",
      }
    case "Australia":
      return {
        zip: "Postcode",
        state: "State",
        city: "City / Suburb",
      }
    default:
      return {
        zip: "Zip Code",
        state: "State",
        city: "City",
      }
  }
}
